module.exports = __webpack_public_path__ + "media/src/img/banner-img-96b911489b769098af0a07f233a28917.png";